import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { NO_TRANSLATE_CLASS, Text } from "@flat-ui";
import { useDateTime } from "@hooks/use-date-time";
import { useTranslate } from "@faro-lotv/foreign-observers";

/**
 * Tooltip content showing created, modified, and last captured dates for a project.
 * Shows absolute dates for clarity when used as a hover tooltip.
 * Used across project cards for both desktop and mobile views.
 */
export function ProjectDateTooltip(t0) {
  const $ = _c(22);
  const {
    project
  } = t0;
  const {
    formatDate
  } = useDateTime();
  const translate = useTranslate();
  let t1;
  if ($[0] !== formatDate || $[1] !== project.createdAt) {
    t1 = formatDate(project.createdAt);
    $[0] = formatDate;
    $[1] = project.createdAt;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      label: "Created",
      value: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== formatDate || $[6] !== project.modifiedAt) {
    t3 = formatDate(project.modifiedAt);
    $[5] = formatDate;
    $[6] = project.modifiedAt;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = {
      label: "Last Updated",
      value: t3
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== formatDate || $[11] !== project.lastCapturedAt || $[12] !== translate) {
    t5 = project.lastCapturedAt ? formatDate(project.lastCapturedAt) : translate("Never");
    $[10] = formatDate;
    $[11] = project.lastCapturedAt;
    $[12] = translate;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = {
      label: "Last Captured",
      value: t5
    };
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t4 || $[18] !== t6) {
    t7 = [t2, t4, t6];
    $[16] = t2;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const dateInfo = t7;
  let t8;
  if ($[20] !== dateInfo) {
    t8 = <Stack spacing={0.5}>{dateInfo.map(_temp)}</Stack>;
    $[20] = dateInfo;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
function _temp(t0) {
  const {
    label,
    value
  } = t0;
  return <Text key={label} variant="bodyS" color="primary">{label}<span className={NO_TRANSLATE_CLASS}>: {value}</span></Text>;
}